/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExportProjectToPdsMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ExportProjectToPdsMutation = { exportProjectToPds: { __typename: 'ExportProjectToPdsResult', workflowId: string, runId: string } };

export type ExportProjectToPds_PdsIntegrationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ExportProjectToPds_PdsIntegrationQuery = { organisationIntegration: { __typename: 'MissingCapabilities', missingCapabilities: Array<Types.Capabilities> } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationIntegrationResult', organisationIntegration?: { __typename: 'OrganisationIntegration', id: string, settings: any } | null } };


export const ExportProjectToPdsDocument = gql`
    mutation ExportProjectToPds($projectId: ID!) {
  exportProjectToPds(input: {projectId: $projectId}) {
    workflowId
    runId
  }
}
    `;
export type ExportProjectToPdsMutationFn = Apollo.MutationFunction<ExportProjectToPdsMutation, ExportProjectToPdsMutationVariables>;

/**
 * __useExportProjectToPdsMutation__
 *
 * To run a mutation, you first call `useExportProjectToPdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportProjectToPdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportProjectToPdsMutation, { data, loading, error }] = useExportProjectToPdsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useExportProjectToPdsMutation(baseOptions?: Apollo.MutationHookOptions<ExportProjectToPdsMutation, ExportProjectToPdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportProjectToPdsMutation, ExportProjectToPdsMutationVariables>(ExportProjectToPdsDocument, options);
      }
export type ExportProjectToPdsMutationHookResult = ReturnType<typeof useExportProjectToPdsMutation>;
export type ExportProjectToPdsMutationResult = Apollo.MutationResult<ExportProjectToPdsMutation>;
export type ExportProjectToPdsMutationOptions = Apollo.BaseMutationOptions<ExportProjectToPdsMutation, ExportProjectToPdsMutationVariables>;
export const ExportProjectToPds_PdsIntegrationDocument = gql`
    query ExportProjectToPds_PdsIntegration {
  organisationIntegration(integrationId: pds) {
    ... on OrganisationIntegrationResult {
      organisationIntegration {
        id
        settings
      }
    }
    ... on MissingCapabilities {
      missingCapabilities
    }
  }
}
    `;

/**
 * __useExportProjectToPds_PdsIntegrationQuery__
 *
 * To run a query within a React component, call `useExportProjectToPds_PdsIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportProjectToPds_PdsIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportProjectToPds_PdsIntegrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportProjectToPds_PdsIntegrationQuery(baseOptions?: Apollo.QueryHookOptions<ExportProjectToPds_PdsIntegrationQuery, ExportProjectToPds_PdsIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportProjectToPds_PdsIntegrationQuery, ExportProjectToPds_PdsIntegrationQueryVariables>(ExportProjectToPds_PdsIntegrationDocument, options);
      }
export function useExportProjectToPds_PdsIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportProjectToPds_PdsIntegrationQuery, ExportProjectToPds_PdsIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportProjectToPds_PdsIntegrationQuery, ExportProjectToPds_PdsIntegrationQueryVariables>(ExportProjectToPds_PdsIntegrationDocument, options);
        }
export function useExportProjectToPds_PdsIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportProjectToPds_PdsIntegrationQuery, ExportProjectToPds_PdsIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportProjectToPds_PdsIntegrationQuery, ExportProjectToPds_PdsIntegrationQueryVariables>(ExportProjectToPds_PdsIntegrationDocument, options);
        }
export type ExportProjectToPds_PdsIntegrationQueryHookResult = ReturnType<typeof useExportProjectToPds_PdsIntegrationQuery>;
export type ExportProjectToPds_PdsIntegrationLazyQueryHookResult = ReturnType<typeof useExportProjectToPds_PdsIntegrationLazyQuery>;
export type ExportProjectToPds_PdsIntegrationSuspenseQueryHookResult = ReturnType<typeof useExportProjectToPds_PdsIntegrationSuspenseQuery>;
export type ExportProjectToPds_PdsIntegrationQueryResult = Apollo.QueryResult<ExportProjectToPds_PdsIntegrationQuery, ExportProjectToPds_PdsIntegrationQueryVariables>;